<div *ngIf="isActive" class="eui-overlay-wrapper">
    <ng-content select="eui-overlay-header"></ng-content>
    <ng-content select="eui-overlay-body"></ng-content>
    <ng-content select="eui-overlay-footer"></ng-content>
</div>
